import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {Link} from 'react-router-dom';

const MaterialTable = ({data, columns}) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((item, i) => (
                <TableCell key={i}>
                    {item.title} 
                </TableCell>
                ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
            {
                data.map((item, i) => (
                    <TableRow
                        key={item.key}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell component="th" scope="row" key={item.name}>
                            <strong>
                                {
                                    <Link to={`/stock/details/${item.ticker}`}>
                                        {
                                            item.name
                                        }
                                    </Link>
                                }
                            </strong>
                        </TableCell>
                        <TableCell key={item.ticker}>
                            {item.ticker}
                        </TableCell>
                        <TableCell key={item.prevclose}>
                            {item.prevclose}
                        </TableCell>
                        <TableCell key={item.change}>
                            {
                                <span style={{color: `${item.change > 0 ? "green" : "red"}`}}> 
                                    <strong>{item.change}</strong> 
                                </span>
                            }
                        </TableCell>
                        <TableCell key={item.changepercentage}>
                                <span style={{color: `${item.changepercentage > 0 ? "green" : "red"}`}}> 
                                    <strong>{item.changepercentage}</strong> 
                                </span>
                        </TableCell>
                        {
                            item.volume
                            ? <TableCell key={item.volume}>
                                {item.volume} 
                            </TableCell>  
                            : <></>
                        }
                        {
                            item.dayhigh
                            ? <TableCell key={item.dayhigh}>
                                {item.dayhigh} 
                            </TableCell>  
                            : <></>
                        }
                        {
                            item.daylow
                            ? <TableCell key={item.daylow}>
                                {item.daylow} 
                            </TableCell>
                            : <></>
                        }
                    </TableRow>
                ))
            }
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default MaterialTable;